// pricingGroupNeighbor returns the index of the nearest element before (dir=-1)
// or after (dir=1) idx whose [field] equals arr[idx][field] AND (when keyFn is
// given) whose keyFn(row) equals keyFn(arr[idx]); -1 if none.
// field === "" and no keyFn → plain neighbour (idx±1) within bounds.
//
// Used by the pricing fee list's group-aware reorder buttons
// (templates/components/pricing_edit_drawer.templ,
// PricingRowReorderButtonsGrouped): the Pflichtgebühren / Zusatzangebote
// sections render the SAME `fees` array filtered by inclusion, so "move up"
// must swap with the nearest row of the same section, never sort the array.
// The fee list passes keyFn = pricingOccupancy.rowKind (Booking step 2):
// occupancy rows (tier/child/single) are `mandatory` too but live in the
// "Belegung & Kinder" card, so a visible fee-section row (rowKind === "")
// only ever swaps with another rowKind === "" row of the same inclusion —
// never with a hidden tier row, whose array order decides which tier is
// first.
export function pricingGroupNeighbor(arr: any[], idx: number, dir: -1 | 1, field: string, keyFn?: (row: any) => unknown): number {
  const same = (j: number) =>
    (!field || arr[j]?.[field] === arr[idx]?.[field]) && (!keyFn || keyFn(arr[j]) === keyFn(arr[idx]));
  for (let j = idx + dir; j >= 0 && j < arr.length; j += dir) {
    if (same(j)) return j;
  }
  return -1;
}
